/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileLinksBlock_itemSearch" | "SharedRespLinksBlock_itemSearch">;
    readonly " $refType": "BuySharedMoreWaysToBrowse_itemSearch";
};
export type BuySharedMoreWaysToBrowse_itemSearch$data = BuySharedMoreWaysToBrowse_itemSearch;
export type BuySharedMoreWaysToBrowse_itemSearch$key = {
    readonly " $data"?: BuySharedMoreWaysToBrowse_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedMoreWaysToBrowse_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedMoreWaysToBrowse_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '7b0e5d30ce527ab632ae3952942fa8f7';
export default node;
